import * as React from "react";

export const Video = ({ videoUrl, type = 'video/mp4', autoplay = false }) => {
    return (
        <video width={'100%'} autoPlay={autoplay} muted={autoplay} loop={autoplay} controls={!autoplay}>
            <source src={videoUrl} type={type}/>
        </video>
    );
};